import { Outlet } from "react-router-dom";
import Header from "./app/components/Header/Header";
import "./styles.scss";
import CookieNotice from "./app/components/CookieNotice/CookieNotice";
import LayoutMobile from "./app/components/LayoutMobile/LayoutMobile";
import { useIsMobile, useMetrikaLoaded, useTrackUserWithMetrika } from "./app/utils/hooks";

const Layout = () => {
  const isLoadedMetrika = useMetrikaLoaded();
  useTrackUserWithMetrika(isLoadedMetrika);
  const { isMobile } = useIsMobile();

  if (isMobile) {
    return <LayoutMobile />;
  }

  return (
    <div className="layout-container">
      <Header />
      <Outlet />
      <CookieNotice />
    </div>
  );
};

export default Layout;